import m from "moment";

export function localeDateFormat(ts: string | undefined): string {
  const d = m(ts);
  if (!ts) return "";
  if (d.isValid()) return d.format("DD/MM/YYYY");
  console.error("Unparseable date:", ts);
  return ts;
}

export function localeDateTimeFormat(ts: string | undefined): string {
  const d = m(ts);
  if (!ts) return "";
  if (d.isValid()) return d.format("DD/MM/YYYY HH:mm:ss");
  console.error("Unparseable date:", ts);
  return ts;
}
